import { testimonials } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

function Stars({ rating }: { rating: number }) {
  return (
    <div className="flex gap-0.5 text-accent-500" aria-label={`${rating} 星评价`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`${i < rating ? "ri-star-fill" : "ri-star-line"} text-sm`}
          aria-hidden="true"
        ></i>
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section id="reviews" className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="用户口碑"
        title="他们说香香漫画很好看"
        subtitle="来自漫画爱好者的真实反馈。好漫画值得被更多人看见，也谢谢你的一路陪伴。"
        align="center"
      />

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6"
          >
            <Stars rating={item.rating} />
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
              {item.text}
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
              <span
                className={`flex h-10 w-10 items-center justify-center rounded-full text-base font-bold text-white ${item.color}`}
                aria-hidden="true"
              >
                {item.name.slice(0, 1)}
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-950">{item.name}</p>
                <p className="text-xs text-foreground-500">{item.role}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}